import useIdleTimer from 'hooks/useIdleTimer';
import { createContext, useEffect, useState } from 'react';
import { DoLogout } from 'services/authentication';
import { GetAppData, GetCount } from 'services/data';
import { ReadMe } from 'services/me';
import { ReadObject, SaveObject } from '../services/storage';

export const CoreContext = createContext({});

export const CoreState = ({ children }) => {
  const [modal, setModal] = useState(null);
  const [searchExpression, setSearchExpression] = useState('');
  const [user, setUser] = useState(
    ReadObject('user') ? ReadObject('user') : []
  );
  const [content, setContent] = useState(null);
  // Indicadores do ticker do header. Ficam no contexto, e nao no proprio
  // Header, porque ele e remontado a cada troca de rota: buscar ali fazia
  // uma chamada por navegacao e deixava o cabecalho sem dado no meio-tempo.
  const [appData, setAppData] = useState(null);
  const [sideOpened, setSideOpened] = useState(true);
  const [openMenus, setOpenMenus] = useState(() => {
    const saved = localStorage.getItem('Evon:openMenus');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(
    () => localStorage.setItem('Evon:openMenus', JSON.stringify(openMenus)),
    [openMenus]
  );

  const toggleMenu = (menuName) => {
    setOpenMenus((prev) =>
      prev.includes(menuName)
        ? prev.filter((name) => name !== menuName)
        : [...prev, menuName]
    );
  };

  // Callback executado após 1 minuto de inatividade
  useIdleTimer(
    async () => {
      await DoLogout();
      window.location.href = '/login';
    },
    1000 * 60 * 59
  ); /** 1 minuto */
  const reloadMe = async () => {
    const result = await ReadMe();
    if (result?.id) {
      setUser(result);
    }
    return result;
  };
  const filterExpression = (item) => {
    return (
      !searchExpression ||
      Object.keys(item).filter(
        (k) =>
          `${item[k]}`.toLowerCase().indexOf(searchExpression.toLowerCase()) !==
          -1
      ).length > 0
    );
  };

  const reloadContent = async (recarregar) => {
    if (!content || recarregar) {
      const count = await GetCount();
      setContent({ ...count });
    }
  };

  const reloadAppData = async (recarregar) => {
    if (appData && !recarregar) {
      return;
    }
    try {
      setAppData(await GetAppData());
    } catch (err) {
      console.error('Erro ao carregar indicadores do header', err);
    }
  };

  const contextValue = {
    user,
    setUser,
    modal,
    setModal,
    searchExpression,
    setSearchExpression,
    filterExpression,
    reloadMe,
    content,
    reloadContent,
    appData,
    reloadAppData,
    sideOpened,
    setSideOpened,
    openMenus,
    toggleMenu,
  };

  // to persist state when app reload
  useEffect(() => SaveObject('user', user), [user]);

  return (
    <CoreContext.Provider value={contextValue}>{children}</CoreContext.Provider>
  );
};
